export const stg_arg_bitmaps = [
  0,
  0,
  0,
  0,
  65,
  1,
  65,
  65,
  65,
  194,
  964,
  16328,
  194,
  66,
  130,
  2,
  451,
  195,
  323,
  67,
  387,
  131,
  259,
  3,
  4,
  5,
  6,
  7,
  8
];
